import React, {useMemo, useState} from 'react';
import styled, {useTheme} from "styled-components";
import CustomClanDetailTable from "./CustomClanDetailTable";
import useClanDetailApi from "../../../common/hooks/clan/useClanDetailApi";
import SnsImage from "../../common/SnsImage";
import CustomClanDetailNavigator from "./CustomClanDetailNavigator";
import {ga4SendOnce, sortChampData} from "../../../function";
import CustomClanTags from "../CustomClanTags";
import CustomClanFavoriteButton from "../CustomClanFavoriteButton";
import {FlexBox, MarginBox} from "../../ui/styled";
import useStateWithGa4 from "../../../common/hooks/useStateWithGa4";
import {GA4_CUSTOM_CLAN_DETAIL_CLICKED} from "../const/ga4";
import {serverTypeToString} from "../function/customClanFunction";
import useInputValue from "../../../common/hooks/useInputValue";
import {useHistory, useLocation} from "react-router-dom";

const Wrapper = styled.div`
  width: 100%;
`;
const ProfileWrapper = styled.div`
  height: 230px;
  position: relative;
  overflow: hidden;
  background-color: ${props => props.theme.color.site_main_color};
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
`;
const BannerImageBox = styled.div`
  width: 100%;
  height: 230px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const ProfileBannerImage = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  height: 230px;
  object-fit: cover;
  filter: blur(30px);
`;
const ProfileBannerColorBox = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  height: 230px;
  object-fit: cover;
  background-color: ${props => props.theme.color.site_main_color};
  border: 1px solid ${props => props.theme.color.default_border_color};
`;

const ImgColorBox = styled.div`
`;
const StreamingBox = styled.div`
  position: absolute;
  bottom: 37px;
  right: 28px;

  .imgBox + .imgBox {
    margin-left: 10px;
  }
`;
const ContentBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  padding: 21.5px 48px;
`;
const ContentImgBox = styled.div`
  width: 276px;
  height: 155px;
  overflow: hidden;
  border-radius: 6px;

  img {
    object-fit: cover;
  }
`;

const ContentInfoBox = styled.div`
  margin-left: 32px;
  margin-top: 16px;
`;
const InfoNameBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`;
const InfoName = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  margin: 0 16px;
`;

const InfoTitle = styled.div`
  margin-right: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  vertical-align: middle;
  color: ${props => props.theme.color.dark_200};
`;

const ClanTag = styled.div`
  width: 55px;
  height: 24px;
  font-weight: 700;
  font-size: 16px;
  background-color: ${props => props.theme.color.blue_100};
  color: #fff;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const TagBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
`;
const TagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const TagBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const PersonCountSpan = styled.span`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
`;

const DescriptionText = styled.div`
  width: 40px;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  opacity: 0.6;
  color: #fff;
`;

const DescriptionInfoText = styled.div`
  margin-left: 8px;
  white-space: pre-line;;
  max-width: 550px;
  line-height: 1.2;
`;
const TableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 8px;
  overflow: hidden;
`;
const TableBox = styled.div`
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
`;

const LIST_COUNT = 20;
const DEFAULT_SORT = [{
    sortType: false,
    value: 'cnt'
}, {
    sortType: false,
    value: 'win_rate',
}, {
    sortType: false,
    value: 'kda'
}];

const DetailGreenButton = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 160px;
  border-radius: 6px;
  height: 36px;
  color: ${props => props.theme.color.site_main_color};
  background-color: ${props => props.theme.color.green_100};
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
`;


const ClanInfoBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;
const calcInitTab = ({data, tab}) => {
    if (data.server_type === 2) {
        return 'member'
    }

    if (tab === 'member' || tab === 'intro') {
        return tab
    }
    return 'intro'
}
const CustomClanDetailContent = () => {
    const location = useLocation();
    const history = useHistory();
    const searchParams = useMemo(() => {
        try {
            return new URLSearchParams(location?.search)
        } catch (e) {
            return new URLSearchParams('')
        }
    }, [location?.search]);
    const theme = useTheme();
    const [page, setPage] = useStateWithGa4({init: 1, event: GA4_CUSTOM_CLAN_DETAIL_CLICKED});
    const [inputValue, setInputValue] = useInputValue('')
    const {query, data} = useClanDetailApi()
    const [imgError, setImgError] = useState(!data.profile_image_url)
    const [currentTab, setCurrentTab] = useStateWithGa4({
        init: calcInitTab({data, tab: searchParams.get('tab')}),
        event: GA4_CUSTOM_CLAN_DETAIL_CLICKED
    })


    const onChangeCurrentTab = (value) => {
        setCurrentTab(value)
        setInputValue({target: {value: ""}});
        const urlSearchParams = new URLSearchParams('');
        urlSearchParams.set('tab',value)
        history.replace({
            pathname: location.pathname,
            search: urlSearchParams.toString()
        })
    }


    const addNumberList = useMemo(() => {
        try {
            const list = data.tournament_stats.tournament_stats_all_list
            const map = sortChampData(list, DEFAULT_SORT);
            const addNumbers = map.map((data, index) => {
                return {
                    ...data,
                    rank: index + 1
                }
            });
            return addNumbers
        } catch (e) {
            return []
        }
    }, [data]);


    const filterBySearch = useMemo(() => {
        try {
            const normalize = (str) => str.replace(/\s+/g, "").toLowerCase();
            const searchName = new RegExp(`^${normalize(inputValue)}`);
            return addNumberList.filter((data) => searchName.test(normalize(data.riot_name)))
        } catch (e) {
            return addNumberList
        }
    }, [addNumberList, inputValue])

    const currentMap = useMemo(() => {
        try {
            // const currentSort = SORT_LIST[sort]
            const END_LIST = page * LIST_COUNT;
            const BEGIN_LIST = END_LIST - LIST_COUNT > 0 ? END_LIST - LIST_COUNT : 0;
            return filterBySearch.slice(BEGIN_LIST, END_LIST)
        } catch (e) {
            return []
        }
    }, [page, filterBySearch]);


    const pageTotal = useMemo(() => {
        try {
            return Math.ceil(filterBySearch.length / LIST_COUNT)
        } catch (e) {
            return 0;
        }
    }, [currentMap])
    const onClickGoToPage = (value) => {
        setPage(value)
    }


    const onClickToFist = () => {
        setPage(1)
    }

    const onClickToEnd = () => {
        setPage(pageTotal)
    };

    const onClickPrev = () => {
        if (page > 1) {
            setPage(prev => prev - 1);
        }
    };

    const onClickNext = () => {
        if (page < pageTotal) {
            setPage(prev => prev + 1)
        }
    };

    const serverType = serverTypeToString(data.server_type)

    return (
        <Wrapper>
            <ProfileWrapper>
                <StreamingBox onClick={() => ga4SendOnce(GA4_CUSTOM_CLAN_DETAIL_CLICKED)}>
                    <SnsImage
                        influData={{
                            discord: data.discord_link,
                            kakao: data.kakao_link,
                            chzzk: data.chzzk,
                            kick: data.etc_link,
                            afreecatv: data.soop,
                            youtube: data.youtube
                        }}
                        height={32}
                        width={32}
                    />
                </StreamingBox>
                <ContentBox>
                    <ContentImgBox>
                        {imgError ?
                            <img
                                src={`${theme.icon.path}/connect/img_connect_card_detail_default.png`}
                                alt={''}
                                width={276}
                                height={155}
                            />
                            :
                            <img
                                src={data.profile_image_url}
                                alt={''}
                                width={276}
                                height={155}
                            />
                        }

                    </ContentImgBox>
                    <ContentInfoBox>
                        <InfoNameBox>
                            <ClanTag>
                                Serv
                            </ClanTag>
                            <InfoName>
                                {data.server_name}
                            </InfoName>
                            <CustomClanFavoriteButton data={data}/>
                        </InfoNameBox>
                        <TagBoxWrapper>

                            <TagWrapper>
                                <InfoTitle>
                                    서버 유형 :
                                </InfoTitle>
                                <FlexBox height={'auto'}>
                                    {data.server_type > 0 &&
                                        <MarginBox margin={'0 4px 0 0'}>
                                            <img src={`${theme.icon.path}/connect/${serverType.img}`} width={20}
                                                 height={20} alt={''}/>
                                        </MarginBox>

                                    }

                                    <PersonCountSpan>
                                        {serverType.title}
                                    </PersonCountSpan>
                                </FlexBox>

                            </TagWrapper>
                            <TagWrapper>
                                <InfoTitle>
                                    멤버 수:
                                </InfoTitle>
                                <div>
                                    <PersonCountSpan>
                                        {data.p_num}
                                    </PersonCountSpan>
                                </div>

                            </TagWrapper>
                            <TagWrapper>
                                <InfoTitle>
                                    태그:
                                </InfoTitle>
                                <TagBox>
                                    {data.tags.map((item, index) => {
                                        return (
                                            <CustomClanTags value={item} key={index} isColor={true}/>
                                        )
                                    })}
                                </TagBox>
                            </TagWrapper>
                        </TagBoxWrapper>
                        <JoinButtonController data={data}/>
                    </ContentInfoBox>
                </ContentBox>
            </ProfileWrapper>
            <CustomClanTab currentTab={currentTab} setCurrentTab={onChangeCurrentTab}
                           count={data.tournament_stats.all_count}
                           introData={data}/>

            {currentTab === 'member' ?
                <ClanInfoBox>
                    <ActiveUserCount>
                        <ActiveUserTitle>
                            <span>참여 멤버 수: <ActiveUserNumber>{data.tournament_stats.all_count}</ActiveUserNumber></span>
                        </ActiveUserTitle>
                    </ActiveUserCount>
                    <ClanSearch inputValue={inputValue} onChangeInputValue={setInputValue}/>
                </ClanInfoBox>
                :
                null
            }
            <RenderController currentTab={currentTab} onClickGoToPage={onClickGoToPage} onClickNext={onClickNext}
                              onClickPrev={onClickPrev} page={page} currentMap={currentMap} onClickToEnd={onClickToEnd}
                              onClickToFist={onClickToFist} introData={data} pageTotal={pageTotal}
            />

        </Wrapper>
    );
};

const CrewTextBox = styled.div`
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};

`;

const JoinButtonController = ({data}) => {

    const serverLinkList = [{
        title: '카카오톡 링크', value: data.kakao_link

    }, {
        title: 'SOOP 링크',
        value: data.soop,
    }, {
        title: '디스코드 링크',
        value: data.discord_link
    }, {
        title: 'Chzzk 링크',
        value: data.chzzk
    }, {
        title: 'Youtube 링크',
        value: data.youtube
    }, {
        title: '기타 링크',
        value: data.etc
    }]
    const joinLinkTransform = useMemo(() => {
        const findItem = serverLinkList.find((data) => data.title === data.join_link);
        if (!findItem) {
            return data.join_link
        }
        return findItem.value
    }, [data.join_link])

    if (data.server_type === 2) {
        return (
            <CrewTextBox>
                ※ 친구나 동아리 등 지인끼리 운영하는 모임으로 멤버 모집 없는 서버 입니다.
            </CrewTextBox>
        )
    }


    if (data.join_link) {
        return (
            <div>
                <a href={joinLinkTransform} onClick={() => ga4SendOnce(GA4_CUSTOM_CLAN_DETAIL_CLICKED)}>
                    <DetailGreenButton>
                        서버 가입하기
                    </DetailGreenButton>
                </a>
            </div>
        )
    }
    return null
}

const IntroWrapper = styled.div`
  width: 100%;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.color.white_201};
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
`;
const IntroTextBox = styled.div`
  max-width: 760px;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  white-space: pre-line;
`;

const EmptyBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: ${props => props.theme.color.white_201};
  border: 1px solid ${props => props.theme.color.default_border_color};
  width: 100%;
  height: 200px;
`;
const RenderController = ({
                              serverType,
                              currentTab,
                              currentMap,
                              onClickGoToPage,
                              onClickNext,
                              onClickPrev,
                              page,
                              pageTotal,
                              onClickToEnd,
                              onClickToFist,
                              introData,
                          }) => {

    if (currentTab === 'member' && currentMap.length === 0) {
        return (
            <EmptyBox>
                멤버가 없습니다
            </EmptyBox>
        )
    }

    if (currentTab === 'member') {
        return (
            <TableWrapper>
                <TableBox>
                    <CustomClanDetailTable list={currentMap}
                                           serverType={introData.server_type}/>
                </TableBox>
                <CustomClanDetailNavigator
                    onClickGoToPage={onClickGoToPage} onClickNext={onClickNext} onClickPrev={onClickPrev}
                    currentPage={page} lastPage={pageTotal} onClickToEnd={onClickToEnd}
                    onClickToFist={onClickToFist}/>
            </TableWrapper>
        )
    }

    if (currentTab === 'intro' && (!introData.intro_text && !introData.intro_image_url)) {
        return (
            <EmptyBox>
                소개가 없습니다.
            </EmptyBox>
        )
    }

    return (
        <IntroWrapper>
            {introData?.intro_image_url &&
                <MarginBox margin={'0 0 10px 0'}>
                    <img src={introData.intro_image_url} alt={''} width={600}/>
                </MarginBox>}
            {introData.intro_text &&
                <IntroTextBox>
                    {introData.intro_text}
                </IntroTextBox>}
        </IntroWrapper>
    )
}

const ClanTabWrapper = styled.div`
  margin: 16px 0 8px 0;
  padding: 0 16px;
  height: 45px;
  width: 100%;
  background-color: ${props => props.theme.color.site_main_color};
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

`;

const ClanTabItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 29px;
  border-radius: 6px;
  background-color: ${props => {
    let color = 'transparent';
    if (props.selected) {
      color = props.theme.color.white_200;
    }
    return color
  }};
  color: ${props => {
    let color = props.theme.color.dark_200
    if (props.selected) {
      color = props.theme.color.dark_100;
    }
    return color
  }};
  border: 1px solid ${props => {
    let color = 'transparent'
    if (props.selected) {
      color = props.theme.color.default_border_color
    }
    return color
  }};
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;

  &:hover {
    background-color: ${props => {
      return props.theme.color.white_200
    }};

  }
`;
const TabBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;
const ActiveUserCount = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const ActiveUserTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
`;
const ActiveUserNumber = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${props => props.theme.color.green_100}
`;
const CustomClanTab = ({currentTab, setCurrentTab, count, introData}) => {
    const list =
        introData.server_type === 2 ?
            [{
                title: "멤버",
                value: 'member'
            }]
            :
            [{
                title: '소개',
                value: 'intro'
            }, {
                title: "멤버",
                value: 'member'
            }]

    return (
        <ClanTabWrapper>
            <TabBox>
                {list.map((data) => {
                    return (
                        <ClanTabItem key={data.value} onClick={() => setCurrentTab(data.value)}
                                     selected={data.value === currentTab}>
                            {data.title}
                        </ClanTabItem>
                    )
                })}
            </TabBox>

        </ClanTabWrapper>
    )
}

const TableInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const MemberButton = styled.button`
  width: 98px;
  height: 35px;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.color.green_100};
  background-color: ${props => props.theme.color.green_200};
  color: ${props => props.theme.color.green_100};
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 6px;
  height: 35px;

  select {
    &:hover {
      background-color: ${props => props.theme.color.white_200};
    }

    cursor: pointer;
    color: ${props => props.theme.color.dark_200};
    border: 1px solid ${props => props.theme.color.dark_200};
    border-radius: 6px;
    padding: 0 8px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 106px;
    height: 100%;
    background: ${props => `url("${props.theme.icon.path}/clan/region_arrow.svg")`} no-repeat;
    background-position: calc(100% - 10px) center !important;
  }

  option {
    background: ${props => props.theme.color.site_main_color};
    color: ${props => props.theme.color.dark_200};
  }
`;
const TableInfo = () => {
    return (
        <TableInfoWrapper>
            <MemberButton>
                멤버
            </MemberButton>
            <SelectWrapper>
                <select>
                    <option>KR</option>
                </select>
            </SelectWrapper>
        </TableInfoWrapper>

    )
}

const ClanSearchWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  width: 240px;
  background-color: ${props => props.theme.color.white_201};
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
  padding: 0 16px;
`;

const InputBar = styled.input`
  color: ${props => props.theme.color.dark_100};
  background-color: transparent;
  border: 0;
  margin-right: 6px;
  flex: 1;
  font-size: 14px;
  padding: 0;

  ::placeholder {
    color: ${props => props.theme.color.dark_200};
  }
`;

const ClanSearch = ({inputValue, onChangeInputValue}) => {
    const theme = useTheme();
    return (
        <ClanSearchWrapper>
            <InputBar
                autoComplete={'off'}
                value={inputValue}
                onChange={onChangeInputValue}
                placeholder={'멤버 검색'}
            />
            <button>
                <img
                    src={`${theme.icon.path}/ico_search_w.svg`}
                    width={18}
                    height={18}
                />
            </button>
        </ClanSearchWrapper>
    )
}

export default CustomClanDetailContent;